module.exports = function () {
    const counterText = document.querySelectorAll(".counter-text");
    if ( !counterText.length ) return;
    
    for (const counter of counterText) {
        const button = counter.querySelector(".counter-sup");
        const toolTip = counter.querySelector(".counter-tooltip");
        
        button?.addEventListener("mouseover", () => {
            closeAllTooltips();
            document.addEventListener("click", closeOutSide);
            
            setTimeout(() => {
                toolTip.classList.remove("invisible", "opacity-0");
            })
        })

        function closeOutSide(e) {
            if ( !toolTip.contains(e.target) ) {
                closeAllTooltips();
            }
        }
    }
    
    function closeAllTooltips() {
        document.querySelectorAll(".counter-tooltip").forEach(tooltip => {
            tooltip.classList.add("invisible", "opacity-0");
        })
    }
}